import { db } from "@/firebase";
// import firebase from "firebase/app";

export const state = {
  domains: []
};
export const mutations = {
  SET_DOMAINS(state, domainData) {
    if (state.domains == null) {
      state.domains = [];
    }
    state.domains.push(domainData);
  },
  EDIT_DOMAIN(state, newData) {
    state.domains.find((d, index) => {
      if (d.id == newData.id) {
        state.domains[index] = { ...newData };
      }
    });
  }
};
export const actions = {
  loadAllDomains({ commit, state }) {
    if (state.domains.length < 1) {
      db.collection("domains").onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(change => {
          if (change.type === "added") {
            let tempDomain = {
              id: change.doc.id,
              ...change.doc.data()
            };
            commit("SET_DOMAINS", tempDomain);
          }
        });
      });
    }
  },
  createNewDomain({ dispatch }, newDomain) {
    db.collection("domains")
      .add(newDomain)
      .then(() => {
        const notification = {
          type: "success",
          message: "New Domain added!"
        };
        dispatch("notification/add", notification, { root: true });
      })
      .catch(error => {
        const notification = {
          type: "error",
          message: "Something went wrong:" + error.message
        };
        dispatch("notification/add", notification, { root: true });
      });
  },
  editDomain({ commit, dispatch }, domain) {
    const { id, ...updatedDomain } = domain;
    let docRef = db.collection("domains").doc(id);
    docRef
      .update(updatedDomain)
      .then(() => {
        let tempDom = { id, ...updatedDomain };
        commit("EDIT_DOMAIN", tempDom);
        const notification = {
          type: "success",
          message: "Domain updated successfully!"
        };
        dispatch("notification/add", notification, { root: true });
      })
      .catch(function(error) {
        console.error("Error updating document: ", error);
      });
  }
};
export const getters = {
  getDomains(state) {
    if (state.domains != null) return state.domains;
    else return null;
  }
};
